import axios from 'axios';
import React from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { Field, reduxForm } from 'redux-form';
import CustomerType from '../../component/CustomerType';
import { RenderSearchForm } from '../../component/formInput';
import Pagination from '../../component/Pagination';
import moment from 'moment';
import BlockUI from '../../component/BlockUI';
import { ToastContainer, toast } from 'react-toastify';

var _ = require('lodash');
var numeral = require('numeral');

const current_year = parseInt(moment().format("YYYY"));
let year_list = _.range(2018, current_year + 1);

function AmountLevelCSS(level) {
  let style = null;
  switch(level) {
    case 2 : {
      return ({fontSize: 14, color: "brown"})
    }
    case 3 : {
      return ({fontSize: 15, color: "blue"})
    }
    case 4 : {
      return ({fontSize: 16, color: "green"})
    }
    case 5 : {
      return ({fontSize: 17, color: "pink"})
    }
    case 6 : {
      return ({fontSize: 18, color: "orange"})
    }
    case 7 : {
      return ({fontSize: 19, color: "red"})
    }
  }
}

function AverageLevel(total_amount) {
  let level = 0;
  if(total_amount >= 40000000) {
    level = 2;
  }
  if(total_amount >= 60000000) {
    level = 3;
  }
  if(total_amount >= 90000000)  {
    level = 4;
  }
  if(total_amount >= 120000000) {
    level = 5;
  }
  if(total_amount >= 150000000) {
    level = 6;
  }
  if(total_amount >= 200000000) {
    level = 7;
  }
  return level;
}

function AgencyRows(year_selected, data, role_path, billing_data, onBonusDeposit) {
  const rows = _.map(data, function(i, index) {
    const level = AverageLevel(i.invoice_without_vat_sum);
    const billing_match = _.find(billing_data, (bill) => bill.user_id == i.agency.id);
    return (
      <tr key={index}>
        <td>
          {i.agency.email}
          <br/>
          <small>{i.agency.full_name}-{i.agency.phone}</small>
        </td>
        <td>
          {i.agency.sale ? i.agency.sale.email : "N/A"}
          <br/>
          <small className="display-block text-muted text-size-small">
            {i.agency.sale ? i.agency.sale.full_name : "N/A"}
          </small>
        </td>
        <td >
          {CustomerType(i.agency)}
        </td>
        <td className="text-orange">
          {numeral(i.invoice_without_vat_sum).format("0,0")}
        </td>
        <td style={AmountLevelCSS(level)}>
          {level == 0 && numeral("0").format("0,0")}
          {level == 2 && numeral("3000000").format("0,0")}
          {level == 3 && numeral("5000000").format("0,0")}
          {level == 4 && numeral("9000000").format("0,0")}
          {level == 5 && numeral("12000000").format("0,0")}
          {level == 6 && numeral("16000000").format("0,0")}
          {level == 7 && numeral("25000000").format("0,0")}
        </td>
        <td>
          {billing_match ? <i className="icon-check" style={{color: "green"}}> </i> : <i className="icon-cross" style={{color: "red"}}></i>}
        </td>
        <td>
          <div className="icons-list">
            <div className="dropdown">
              <a href="#" className="list-icons-item" data-toggle="dropdown">
                <i className="icon-menu9"></i>
              </a>
              <div className="dropdown-menu dropdown-menu-right">
                {/* 1. Nạp tiền vào khoản khuyến mãi */}
                {level > 0 && !billing_match && <a onClick={() => onBonusDeposit(level,i.agency.id)} className="dropdown-item">
                  <i className="icon-add"></i> Tặng Tiền Khuyến Mãi
                </a>}
                {/* 2. Danh Sách Đơn Hàng */}
                 <Link to={role_path + "/agency/average/related/invoice/"+ i.agency.id +"/year/"+ year_selected} className="dropdown-item">
                  <i className="icon-list-numbered"></i> Danh Sách Đơn Hàng
                </Link>
              </div>
            </div>
          </div>
        </td>
      </tr>
    )
  })
  return rows;
}

class AgencySalesReport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      table_data: [],
      table_query: {
        current_page: 1,
        number_of_row: 20,
        sort_asc: false,
        year: current_year,
        search_value: "",
        search_field: "search"
      },
      isLoading: false,
      billing_data: []
    }
  }

  componentDidMount() {
    this.listReload(this.state.table_query);
  }

  gotoPage = (page) => {
    const table_query = {
      ...this.state.table_query,
      current_page: page
    };
    this.listReload(table_query);
  }
  
  listReload = (table_query) => {
    const self = this;
    this.setState({
      isLoading: true
    })
    axios({
      method: 'post',
      url: window.api_url + '/admin/api/agency/total/sales/list',
      withCredentials: true,
      data: table_query
    }).then(function (response) {
      self.getBillingByDescription(table_query);
      self.setState({
        ...self.state,
        table_query: table_query,
        table_data: response.data.data,
        isLoading: false
      })
    });
  }

  onSearchTxtChange = (event) => {
    const table_query = {
      ...this.state.table_query,
      search_value: event.target.value
    };
    this.setState({
      ...this.state,
      table_query: table_query
    });
  }

  onSearchSubmit = (values) => {
    const search_value = values.search ? values.search : "";
    const { history, role_path } = this.props;
    
    const table_query = {
      ...this.state.table_query,
      current_page: 1,
      search_value: search_value
    };
    history.push(role_path + "/report/agency/average/list/?search=" + search_value);
    this.listReload(table_query);
  }
  

  getBillingByDescription = (table_query) => {
    const self = this;
    axios({
      method: 'post',
      url: window.api_url + '/admin/api/billing/list/by_description',
      withCredentials: true,
      data: {
        type: "SECONDARY",
        billing_description: "Tặng tiền thưởng đại lý năm " + table_query.year
      }
    }).then(function (response) {
      if(!response.data.isError) {
        self.setState({
          ...self.state,
          billing_data: response.data.data
        })
      }
    });
  }

  clearDataFilter = () => {
    const { reset } = this.props;
    const table_query = {
      ...this.state.table_query,
      search_value: "",
      current_page: 1
    };
    this.setState({
      ...this.state,
      table_query: table_query
    });
    reset();
    this.listReload(table_query);
  }

  onChangeYear = (year) => {
    const { table_query } = this.state;
    const data = {
      ...table_query,
      year: year
    }
    this.listReload(data)
  }

  onBonusDeposit = (level, customer_id) => {
    const {table_query} = this.state;
    const year = table_query.year;
    const self = this;
    const alert_confirm = window.confirm("Bạn có chắc sẽ tặng tiền cho đại lý này.");
    if(alert_confirm) {
      axios({
        method: 'post',
        url: window.api_url + '/admin/api/agency/bonus/deposit',
        withCredentials: true,
        data: {
          level: level,
          customer_id: customer_id,
          year: year
        }
      }).then(function (response) {
        if(!response.data.isError) {
          toast.success("Tặng Tiền Thành Công !")
          self.listReload(table_query);
        }else {
          toast.error("Tặng Tiền Thất Bại !")
        }
      });
    }
  }
  
  onKeyPess = (key_code) => {
    const { history, role_path } = this.props;
    if (key_code == "Escape") {
      history.push(role_path + "/report/agency/average/list")
      this.clearDataFilter();
    }
  }

  render() {
    const { handleSubmit, role_path } = this.props;
    const { table_query, table_data, isLoading, billing_data } = this.state;
    const year = table_query.year;
    const year_option = _.map(year_list, (i,index) => <option key={index} value={i}>Năm: {i}</option>);

    return(
      <React.Fragment>
        {isLoading && <BlockUI />}
        <div className="page-header">
          <div className="page-header-content header-elements-md-inline">
            <div className="page-title d-flex">
              <ToastContainer />
              <h4>
                <i className="icon-paragraph-justify2 mr-2"></i>
                <span className="text-semibold"> Thống Kê Doanh Số Đại Lý</span>
              </h4>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="card card-body">
              <form style={{display:"inline-flex"}} onSubmit={handleSubmit(this.onSearchSubmit)}>
                <div style={{ width:"100%", paddingRight:5}}>
                  <Field
                    name="search"
                    placeholder="Email khách hàng, tên khách hàng."
                    defaultValue = {table_query.search_value}
                    onKeyAction={(ev)=> this.onKeyPess(ev)}
                    component={RenderSearchForm}
                  />
                <select
                  style={{ maxWidth: "100px", minWidth: "350px" }} 
                  className="form-control"
                  value={year}
                  onChange={(event) => this.onChangeYear(parseInt(event.target.value))}>
                  {year_option}
                </select>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="table-responsive">
                <div style={{margin:10}} className="text-align-right">
                </div>
                <table className="table table-togglable table-hover">
                  <thead>
                    <tr>
                      <th data-toggle="true">
                        Email
                        <br/>
                        <small className="display-block text-muted text-size-small">Họ Tên - Điện Thoại</small>
                      </th>
                      <th data-hide="phone">
                        Sale Man
                      </th>
                      <th data-hide="phone">
                        Loại
                      </th>
                      <th data-hide="phone">
                        Tổng Doanh Số / Năm
                      </th>
                      <th>
                        Tiền Thưởng
                      </th>
                      <th>
                        Trạng Thái
                      </th>
                      <th className="text-center footable-visible footable-last-column" style={{width: "30px"}}>
                        <i className="icon-menu-open2"></i>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {table_data.data && AgencyRows(year, table_data.data, role_path, billing_data, this.onBonusDeposit)}
                  </tbody>
                </table>
              </div>
            </div>
            <Pagination query={table_query} data={table_data} handle={this.gotoPage}/>
          </div>
        </div>
      </React.Fragment>
    )
  }
}


const mapState = state => ({
  role_path: state.userProfile.role_path,
});

const mapDispatch = (dispatch) => ({
});


const AgencySalesReportWrapper = reduxForm({
  form: 'AgencySalesReport',
  destroyOnUnmount: true,
  enableReinitialize: true,
})(AgencySalesReport);

export default connect(mapState, mapDispatch)(withRouter(AgencySalesReportWrapper));
